import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Dropdown, SelectOption } from 'common.ui';
import { useTranslation } from 'react-i18next';

type RoleSectionProps = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  form: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  BoundDropdown: React.ComponentType<any>;
  applications: { id: string; text: string }[];
  roles: { id: string; text: string }[];
  organizationOptions: SelectOption[];
  shouldRenderOrganizationDropdown: boolean;
  hasRoleSelected: boolean;
  isValidOrganization: boolean;
  isRolesLoading: boolean;
  disabled?: boolean;
  appValue: string;
  roleValue: string;
  orgValue: string;
  resetKey: number;
  onApplicationChange: (appId: string) => void;
  onRoleChange: (roleId: string) => void;
  onOrganizationChange: (orgId: string) => void;
};

function RoleSection({
  form,
  BoundDropdown,
  applications,
  roles,
  organizationOptions,
  shouldRenderOrganizationDropdown,
  hasRoleSelected,
  isValidOrganization,
  isRolesLoading,
  disabled = false,
  appValue,
  roleValue,
  orgValue,
  resetKey,
  onApplicationChange,
  onRoleChange,
  onOrganizationChange
}: RoleSectionProps) {
  const { t } = useTranslation('pages');

  return (
    <>
      <Row className='mb-0'>
        <Col sm={12}>
          <h3>{t('createUser.roleInfoTitle')}</h3>
        </Col>
      </Row>
      <Row className='mb-2'>
        <Col xs={12} lg={4}>
          <BoundDropdown
            key={`app-${appValue}-${resetKey}`}
            form={form}
            onChange={(e: React.ChangeEvent<HTMLSelectElement>) => onApplicationChange(e.target.value)}
            options={[{ id: '', text: t('createUser.user.form.applicationPlaceholder') }, ...(applications ?? [])]}
            label={t('createUser.user.form.appLabel')}
            name='applicationId'
          />
        </Col>
        <Col xs={12} lg={4}>
          <Dropdown
            key={`role-${roleValue}-${resetKey}`}
            id='givenRole'
            value={roleValue}
            labelText={t('createUser.user.form.roleLabel')}
            options={[{ id: '', text: t('createUser.user.form.rolePlaceholder') }, ...(roles ?? [])]}
            disabled={isRolesLoading || disabled}
            onChange={(e: React.ChangeEvent<HTMLSelectElement>) => onRoleChange(e.target.value)}
          />
        </Col>
        <Col xs={12} lg={4}>
          <Dropdown
            key={`org-${orgValue}-${resetKey}`}
            id='givenRole.organizationId'
            value={orgValue}
            labelText={t('createUser.user.form.organizationLabel')}
            options={[{ id: '', text: t('createUser.user.form.organizationPlaceholder') }, ...organizationOptions]}
            disabled={!shouldRenderOrganizationDropdown || isRolesLoading || disabled}
            aria-describedby={!hasRoleSelected ? 'org-disabled-hint' : undefined}
            onChange={(e: React.ChangeEvent<HTMLSelectElement>) => onOrganizationChange(e.target.value)}
          />
          {!hasRoleSelected && (
            <small id='org-disabled-hint' className='form-section-hint d-block' aria-live='polite'>
              {t('createUser.user.form.organizationDisabledHint')}
            </small>
          )}
          {!isValidOrganization && (
            <div className='text-error'>{t('createUser.user.form.organizationValidationMessage')}</div>
          )}
        </Col>
      </Row>
    </>
  );
}

export default RoleSection;
